import React from "react";
import { Helmet } from "react-helmet-async";
import HeaderTwo from "../components/HeaderTwo";
import BannerTwo from "../components/BannerTwo";
import PromotionalTwo from "../components/PromotionalTwo";
import DealsOne from "../components/DealsOne";
import DiscountOne from "../components/DiscountOne";
import RecentlyViewedOne from "../components/RecentlyViewedOne";
import ShippingTwo from "../components/ShippingTwo";
import FooterTwo from "../components/FooterTwo";
import BottomFooter from "../components/BottomFooter";
import WhyChooseUs from "../components/WhyChooseUs";
import FeaturedProducts from "../components/FeaturedProducts";
import PremuimInk from "../components/PremuimInk";
import Choose from "../components/Choose";
import Faq from "../components/Faq";
import Testimonial from "../components/Testimonial";
import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Breadcrumb from "../components/Breadcrumb";

const HomePageTwo = () => {
  return (
    <>
      <Helmet>
        <title>About Us | Awaneez</title>
      </Helmet>

      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#2694e9" />

      {/* HeaderTwo */}
      <HeaderTwo category={false} />

      {/* PromotionalTwo */}
      <PromotionalTwo />

      {/* Faq */}
      <Faq />

      {/* Testimonial */}
      <Testimonial />

      {/* FooterTwo */}
      <FooterTwo />
    </>
  );
};

export default HomePageTwo;
